import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class PedidoEgresoCalado {
  adaptToBackend (values = {}) {
    const {
      cerealPedido,
      cantidadPedido,
      calleDeBruto,
      caravana,
      calificacionCereal
    } = values
    return {
      cereal: cerealPedido,
      cantidad: cantidadPedido,
      calle_de_bruto: calleDeBruto,
      caravana: caravana,
      calificacion_cereal: calificacionCereal || null
    }
  }

  static deletePedidosDeBrutoACalado (fecha) {
    const axios = getAxiosInstance()
    const pedido = `{"clave": {"fecha_de_pedido": "${fecha}"}}`
    const promise = axios.delete(`pedido_de_bruto_a_calado_pendiente?r=${pedido}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result })
  }

  static getPedidosDeBrutoACalado () {
    const axios = getAxiosInstance()
    const orden = '{"orden": ["fecha_de_pedido"]}'
    const promise = axios.get(`pedido_de_bruto_a_calado_pendiente?r=${orden}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => result.data)
  }

  submitPedidoDeBrutoACalado (values) {
    const axios = getAxiosInstance()
    const valores = this.adaptToBackend(values)
    console.log('valores ', valores)
    const promise = axios.post(`pedido_de_bruto_a_calado`, { valores: { ...valores } })
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then(response => (response.data[0] || {}))
  }

  static eliminarPedido (fecha) {
    const axios = getAxiosInstance()
    const pedido = `{"clave": {"fecha_de_pedido": "${fecha}"}}`
    const promise = axios.delete(`pedido_de_bruto_a_calado?r=${pedido}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then(response => (response.data[0] || {}))
  }
}

export default PedidoEgresoCalado
